import api from './api'
import { ClubEntry } from '../types/club/ClubEntry'

const ClubService = {
  async getClubEntry(
    clubId: string,
    entryId: string,
    token: string,
  ): Promise<ClubEntry> {
    const { data } = await api.get(
      `/v1/clubs/${clubId}/entries/${entryId}/token-auth?token=${token}`,
    )
    return data
  },

  async getMeClubEntry(clubId: string): Promise<ClubEntry> {
    const { data } = await api.get(`/v1/clubs/${clubId}/entries/me`)
    return data
  },

  async acceptClubInvitation(
    clubId: string,
    entryId: string,
    dto: {
      token: string
      amount?: number
    },
  ): Promise<ClubEntry> {
    const { data } = await api.post(
      `/v1/clubs/${clubId}/entries/${entryId}/accept`,
      dto,
    )
    return data
  },

  async requestInvitation(
    clubId: string,
    payload: {
      amount: number
    },
  ): Promise<ClubEntry> {
    const { data } = await api.post(
      `/v1/clubs/${clubId}/request-invitation`,
      payload,
    )
    return data
  },
}

export default ClubService
